<div class="login-background">
  <div class="overlay">
    <div class="login-container">
      <p-card class="login-card">
        <div class="content">
          <!-- <h2 style="font-size: 1.2rem !important">Welcome To</h2> -->
          <img src="assets/logo.png" alt="Logo" class="logo" />

          <p-button
            class="login-btn"
            (onClick)="login()"
            label="Login"
            icon="pi pi-user"
          >
          </p-button>
        </div>
      </p-card>
    </div>
  </div>
</div>
